import { OnInit, AfterViewInit, EventEmitter } from '@angular/core';
import { TiquetsFilter } from '../../models/tiquets-filter';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { TiquetsService } from '../../services/tiquets.service';
import { TiquetsFilterService } from '../../services/tiquets-filter.service';
import { DownloadExcelDialogComponent } from 'path-shared/components/dialogs/download-excel-dialog/download-excel-dialog.component';
import { Builder } from 'path-shared/models/builder';
var TiquetsTiquetsTableComponent = /** @class */ (function () {
    function TiquetsTiquetsTableComponent(tiquetsService, dialog, i18n) {
        this.tiquetsService = tiquetsService;
        this.dialog = dialog;
        this.i18n = i18n;
        this.currentFilter = new TiquetsFilter('id', 'desc'); // Filtro concreto para esta tabla.
        this.highlightedRows = [];
        this.displayedColumns = ['tiquet', 'client', 'email', 'matricula', 'zona', 'tarifa', 'importTiquet', 'importTiquetBono', 'importTiquetMetalic', 'importDevolucio', 'horaCompra', 'horaInici', 'horaFinal'];
        this.currentCount = new EventEmitter();
    }
    Object.defineProperty(TiquetsTiquetsTableComponent.prototype, "sharedFilter", {
        get: function () {
            return this._sharedFilter;
        },
        set: function (val) {
            if (val !== undefined && val !== null) {
                this._sharedFilter = val;
                this.currentFilter.id = val.id;
                this.currentFilter.matricula = val.matricula;
                this.currentFilter.email = val.email;
                this.currentFilter.fechaTicketInicio = val.fechaTicketInicio;
                this.currentFilter.fechaTicketFin = val.fechaTicketFin;
                this.currentFilter.fechaBancoInicio = val.fechaBancoInicio;
                this.currentFilter.fechaBancoFin = val.fechaBancoFin;
                this.currentFilter.zonaSecureId = val.zonaSecureId;
                this.currentFilter.proveidors = val.proveidors;
            }
        },
        enumerable: true,
        configurable: true
    });
    //#region CICLO DE VIDA
    TiquetsTiquetsTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sort.disableClear = true;
        this.dataSource = CustomDataSource.create(this.paginator, new TiquetsFilterService(), 'urlGetTiquets', 'urlGetTiquetsCount');
        this.dataSource.countSubject.subscribe(function (newCount) {
            _this.currentCount.emit(newCount);
        });
    };
    TiquetsTiquetsTableComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // reset the paginator after sorting
        this.sort.sortChange.subscribe(function () {
            _this.paginator.pageIndex = 0;
            _this.load();
        });
        merge(this.sort.sortChange, this.paginator.page)
            .pipe(tap(function () { return _this.currentFilter.updated(); }))
            .subscribe();
        this.load();
    };
    //#endregion
    //#region EVENTOS
    TiquetsTiquetsTableComponent.prototype.paginatorChanged = function (value) {
        // Actualizamos la informacion al detectar un cambio en la paginacion.
        this.load();
    };
    TiquetsTiquetsTableComponent.prototype.updateFilterFromParent = function (val) {
        // Cuando el componente parent nos pasa un nuevo filtro compartido, actualizamos.
        this.sharedFilter = val;
        this.load();
    };
    //#endregion
    //#region OTHERS
    TiquetsTiquetsTableComponent.prototype.load = function () {
        this.currentFilter.paginator.set(this.sort, this.paginator);
        this.dataSource.loadFilter(this.currentFilter, this.i18n('No s\'han trobat registres per tiquets'));
    };
    TiquetsTiquetsTableComponent.prototype.generateExcel = function () {
        var filter = this.currentFilter;
        this.dialog.open(DownloadExcelDialogComponent, {
            closeOnNavigation: false,
            autoFocus: true,
            data: Builder.newDownloadExcelDialogData(this.tiquetsService, filter, this.i18n('Tiquets'), this.sort.direction, this.sort.active)
        });
    };
    return TiquetsTiquetsTableComponent;
}());
export { TiquetsTiquetsTableComponent };
